


























































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Action, Mutation } from 'vuex-class';
import { ProductPagination, ProductPaginationParams, Product } from '@/modules/product';
import LoadingScreen from '@/modules/core/LoadingScreen';
import { Watch, Prop } from 'vue-property-decorator';
import { MutationTypes } from '@/modules/product/store/mutations';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

export interface VDataTablePagination {
    descending: boolean
    page: number
    rowsPerPage: number
    sortBy: string
    totalItems: number
}

export interface TableHeader {
    text: string
    value: string
    sortable?: boolean
    align?: 'right' | 'center' | 'left'
}

/**
 * Lista de productos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    filters: {
        round: (value: number) => _.round(value, 2),
    },
})
export default class ProductList extends Vue {

    /**
     * Si se activa, mostrará el botón para acceder a la pantalla de edición de un
     * producto
     */
    @Prop({type: Boolean, default: true})
    public allowEdit: boolean

    /**
     * Si se activa mostrará la pantalla de carga al iniciar el componente
     */
    @Prop({type: Boolean, default: true})
    public showLoadingScreen: boolean

    /**
     * Si se activa, al hacer click sobre un producto el componente emitirá un evento
     * 'select' con el producto seleccionado
     */
    @Prop({type: Boolean, default: false})
    public allowSelect: boolean

    @Prop({type: Boolean, default: false})
    public fullWidthSearch: boolean

    /**
     * Paginación actual de productos
     */
    @State(state => state.product.pagination)
    public pagination: ProductPagination

    @State(state => state.product.loadingPagination)
    public loadingPagination: boolean

    @State(state => state.product.paginationParams)
    public paginationParams: ProductPaginationParams

    @Action('product/loadPagination')
    public loadPagination: () => void

    @Mutation(`product/${MutationTypes.SetProductPaginationParams}`)
    public setPaginationParams: (params: ProductPaginationParams) => void

    public get searchGridColumns (): KeyValuePair {
        return {
            [`xs${this.fullWidthSearch ? '6' : '3'}`]: true,
        }
    }

    public tablePagination = {}

    public get headers () {
        const headers: TableHeader[] = [
            { text: 'Código de producto', value: 'id' },
            { text: 'Descripción', value: 'name'},
            { text: 'PVP', value: 'pvp'},
            { text: 'Visible', value: 'visible'},
        ]

        if (this.allowEdit) {
            headers.push({ text: 'Acciones', value: 'name', sortable: false, align: 'right'})
        }

        return headers
    }

    public firstLoadingCompleted = false
    public selectedFilter = 'code'
    public searchFilters = [
        { text: 'Por codigo de producto', value: 'code'},
        { text: 'Por nombre de producto', value: 'name'},
    ]

    @Watch('selectedFilter')
    public onSelectedFilter (filter: string) {
        let params = this.paginationParams
        const search = _.get(this.paginationParams, 'filters.searchBy.term', false)
        if (!search) {
            return
        }

        params = _.set(params, 'filters.searchBy.in', filter)
        this.setPaginationParams(params)

        this.loadPagination()
    }

    /**
     * Observa los cambios de la tabla para cargar una nueva paginación desde
     * el servidor
     */
    @Watch('tablePagination')
    public onPagination (pagination: VDataTablePagination) {

        // Actualiza los parámetros de paginación en el estado
        this.setPaginationParams({
            page: pagination.page,
            recordsPerPage: pagination.rowsPerPage,
        })

        this.$emit('pagination')

        this.loadPagination()
    }

    public onSearch = _.debounce(function (this: ProductList, term: string) {
        let params = _.clone(this.paginationParams)
        params = _.set(params, 'filters.searchBy',  { term, in: this.selectedFilter })

        this.setPaginationParams(params)

        this.loadPagination()
    }, 800)

    public async created () {
        if (this.showLoadingScreen) {
            LoadingScreen.show('Cargando lista de productos')
        }

        await this.loadPagination()

        LoadingScreen.hide()
        this.firstLoadingCompleted = true
    }
}
